import React, { useEffect, useState } from "react";

const EVENT_NAME = "app-toast";
const durations = { success: 3500, error: 5000, info: 3500, warning: 4000 };

export const showToast = (message, type = "info") => {
  if (typeof window === "undefined") return;
  const detail = {
    id: Date.now() + Math.random(),
    message,
    type,
  };
  window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail }));
};

const palette = {
  success: { bg: "#0f172a", border: "#10b981" },
  error: { bg: "#0f172a", border: "#ef4444" },
  warning: { bg: "#0f172a", border: "#f59e0b" },
  info: { bg: "#0f172a", border: "#3b82f6" },
};

export const ToastHost = () => {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    const handler = (e) => {
      const toast = e.detail;
      setToasts((prev) => [...prev, toast]);
      const timeout = durations[toast.type] || 3500;
      setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== toast.id));
      }, timeout);
    };
    window.addEventListener(EVENT_NAME, handler);
    return () => window.removeEventListener(EVENT_NAME, handler);
  }, []);

  if (!toasts.length) return null;

  return (
    <div style={containerStyle}>
      {toasts.map((toast) => {
        const colors = palette[toast.type] || palette.info;
        return (
          <div key={toast.id} style={{ ...toastStyle, borderLeft: `4px solid ${colors.border}`, background: colors.bg }}>
            <span>{toast.message}</span>
          </div>
        );
      })}
    </div>
  );
};

const containerStyle = {
  position: "fixed",
  left: "24px",
  bottom: "24px",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  zIndex: 2000,
};

const toastStyle = {
  minWidth: "320px",
  maxWidth: "420px",
  color: "#e2e8f0",
  padding: "12px 14px",
  borderRadius: "12px",
  boxShadow: "0 20px 60px rgba(0,0,0,0.35)",
  backdropFilter: "blur(8px)",
  fontSize: "14px",
};
